import router from './router'
import store from "@/store";
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getConstantRouterNames, addAsyncRoutes } from '@/utils/routerUtil'
import { constantRouterMap } from '@/router/router.config'


// 无需登录就可以进入的页面
const allowList = getConstantRouterNames(constantRouterMap) // no redirect allowList
const defaultRoutePath = '/home'

router.beforeEach((to, from, next) => {
  if (storage.get(ACCESS_TOKEN)) {
    if (store.getters.token === null || store.getters.token === undefined || store.getters.token === '') {
      store.commit('SET_TOKEN', storage.get(ACCESS_TOKEN))
      addAsyncRoutes()
      // 判断是否有匹配的路由
      if (router.match(to.path).matched.length === 0) {
        next({ path: defaultRoutePath })
      } else {
        next({ ...to, replace: true })
      }
    }
    // 判断是否有匹配的路由
    if (router.match(to.path).matched.length === 0) {
      next({ path: defaultRoutePath })
    } else {
      next()
    }
  } else {
    if (allowList.includes(to.name)) {
      // 在免登录名单，直接进入
      next()
    }
    else {
      //账号登录已超时请重新登录
      next({ path: defaultRoutePath })
    }
  }
  // }
})

